import { NavigationPath } from 'constants/navigation';

export function createChatPath(chatId: string, threadId: string): string {
  if (!chatId || !threadId) {
    return NavigationPath.Chats;
  }

  return `${NavigationPath.Chats}/${chatId}/${threadId}`;
}
